/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    height: '100%',
  },
  headerWrap: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: Tokens.spacing['$sp-4'],
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-4'],
    fontSize: Tokens.spacing['$sp-6'],
    justifyContent: 'space-between',
    color: theme.palette.text.primary,
  },
  card: {
    height: 'auto',
  },
  loader: {
    textAlign: 'center',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-3']
  },
  policyRoot: {
    margin: Tokens.spacing['$sp-10'],
    marginTop: Tokens.spacing['$sp-4']
  },
  deleteIcon: {
    cursor: 'pointer',
  },
  contentContainer: {
    marginTop: Tokens.spacing['$sp-6'],
    marginLeft: Tokens.spacing['$sp-6'],
  },
  textInput: {
    width: Tokens.spacing['$sp-100'],
  },
  footerWrap: {
    position: 'absolute',
    right: Tokens.spacing['$sp-10'],
    bottom: Tokens.spacing['$sp-8-5'],
  },
  saveBtnInRolesTab: {
    position: 'absolute',
    right: Tokens.spacing['$sp-10'],
    bottom: Tokens.spacing['$sp-8-5'],
  }
}));